
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacationpackages",
      function () {
        return require("private-next-pages/vacationpackages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacationpackages"])
      });
    }
  